module.exports = __webpack_public_path__ + "static/media/monkey.fa7788bb.svg";